import { Platform, StyleSheet } from 'react-native';
import { brand, neutrals, text } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: -5,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    width: '100%',
    gap: 10,
    zIndex: 2,
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  rightSection: {
    flex: 0.7,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
  },
  checkIcon: {
    width: 12,
    height: 12,
  },
  text: {
    fontSize: 12,
    lineHeight: 15.6, //12 * 130%
    color: text.secondaryText,
    fontWeight: '400',
  },
  textDot: {
    fontSize: 10,
    lineHeight: 6, //12 * 130%
    color: text.secondaryText,
    fontWeight: '400',
  },
  icon: {
    width: 18,
    height: 18,
    color: neutrals.white,
  },
  checkIconContainer: {
    width: 20,
    height: 20,
    borderWidth: 2,
    borderRadius: 100,
    borderColor: brand.main.water,
    backgroundColor: neutrals.white,
    marginRight: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...(Platform.OS === 'web' &&
      ({
        boxShadow: '1px 1px 3.8px rgba(0, 0, 0, 0.3)',
      } as any)),
  },
  checkIconContainerSelected: {
    borderColor: neutrals.white,
    backgroundColor: brand.main.water,
  },
  iconButtonContainer: {
    zIndex: 10,
  },
  iconButton: {
    width: 32,
    height: 32,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  hoverTextContainer: {
    position: 'absolute',
    bottom: 40, // Posizionato sopra l'icona
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
  selectButton: {
    position: 'relative',
    zIndex: 3,
    borderRadius: 20,
    padding: 6,
  },
  selectedButton: {
    backgroundColor: neutrals.white,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 13,
  },
  dropdownContainer: {
    position: 'absolute',
    zIndex: 2,
    top: 10,
  },
  dropdownLookupContainer: {
    position: 'absolute',
    top: 24,
    left: 32,
    backgroundColor: neutrals.white,
    borderRadius: 13,
    paddingVertical: 16,
    minWidth: 145,
    zIndex: 1,
    ...Platform.select({
      web: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.25,
        shadowRadius: 43,
      },
      default: {
        elevation: 8,
      },
    }),
  },
  scrollViewVertical: {
    flex: 1,
    maxHeight: 300,
  },
  dottedLine: {
    borderBottomWidth: 2,
    borderBottomColor: brand.main.water,
    borderStyle: 'dotted',
  },
  sectionWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    gap: 8,
    flexWrap: 'wrap',
  },
});
